/**
 * @generated SignedSource<<9b30b3cd866a30c39711d04ffa2c6515>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespUnavailableContainer_viewer$data = {
  readonly isWordpressArticlesEnabled: boolean | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespFeaturedItemsGridLazy_viewer" | "PdpRespRefetchableSimilarItemsGrid_viewer" | "PdpRespSharedHeroCarousel_viewer" | "PdpRespSharedSellerChatLoader_viewer" | "PdpRespSharedSidebarSellerInfoAndContact_viewer" | "PdpRespUnavailableDetailsTabs_viewer" | "PdpSharedFeaturedRelatedItemsCarouselLazy_viewer" | "PdpSharedSellerItemsCarousel_viewer" | "SharedRespLinksBlock_viewer" | "usePdpSharedTracking_viewer">;
  readonly " $fragmentType": "PdpRespUnavailableContainer_viewer";
};
export type PdpRespUnavailableContainer_viewer$key = {
  readonly " $data"?: PdpRespUnavailableContainer_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespUnavailableContainer_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "afterDisplay"
    },
    {
      "kind": "RootArgument",
      "name": "afterDisplayAndBtNone"
    },
    {
      "kind": "RootArgument",
      "name": "fetchChat"
    },
    {
      "kind": "RootArgument",
      "name": "itemId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespUnavailableContainer_viewer",
  "selections": [
    {
      "alias": "isWordpressArticlesEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "WP_EDITORIAL"
        }
      ],
      "kind": "ScalarField",
      "name": "isEnabledByLocale",
      "storageKey": "isEnabledByLocale(featureName:\"WP_EDITORIAL\")"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "usePdpSharedTracking_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedRespLinksBlock_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespUnavailableDetailsTabs_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSharedHeroCarousel_viewer"
    },
    {
      "condition": "fetchChat",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpRespSharedSellerChatLoader_viewer"
        }
      ]
    },
    {
      "args": [
        {
          "kind": "Literal",
          "name": "useML",
          "value": false
        }
      ],
      "kind": "FragmentSpread",
      "name": "PdpSharedSellerItemsCarousel_viewer"
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "itemId",
          "variableName": "itemId"
        }
      ],
      "kind": "FragmentSpread",
      "name": "PdpRespRefetchableSimilarItemsGrid_viewer"
    },
    {
      "condition": "afterDisplayAndBtNone",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpSharedFeaturedRelatedItemsCarouselLazy_viewer"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpRespFeaturedItemsGridLazy_viewer"
        }
      ]
    },
    {
      "condition": "afterDisplay",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpRespSharedSidebarSellerInfoAndContact_viewer"
        }
      ]
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "fec4292025b850e422e33266bbc959c9";

export default node;
